import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

export const TablePicker = ({ tables = [], selectedTableId, onSelect, onAddTable, loading, canAddTable = false }) => {
  const safeTables = Array.isArray(tables) ? tables : [];

  return (
    <div className="h-full flex flex-col p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Select a Table</h2>
        {canAddTable && (
          <button
            type="button"
            onClick={onAddTable}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-sm font-semibold rounded hover:bg-blue-700"
          >
            <PlusIcon className="h-4 w-4" /> Add Table
          </button>
        )}
      </div>

      {loading && <p className="text-sm text-gray-500">Loading tables…</p>}

      <div className="grid grid-cols-4 gap-3 overflow-auto">
        {safeTables.map((table) => {
          const id = table._id || table.id;
          const number = table.number || table.tableNumber || '?';
          const status = (table.status || 'available').toLowerCase();
          const isSelected = String(selectedTableId) === String(id);
          const statusColor =
            status === 'occupied' ? 'bg-red-100 border-red-300 text-red-900'
            : status === 'reserved' ? 'bg-yellow-100 border-yellow-300 text-yellow-900'
            : 'bg-green-50 border-green-200 text-green-900';
          const ring = isSelected ? 'ring-2 ring-blue-500' : '';
          return (
            <button
              key={id}
              type="button"
              onClick={() => onSelect(table)}
              className={`p-4 rounded-lg border ${statusColor} ${ring} text-left hover:shadow-md transition`}
            >
              <div className="text-2xl font-bold">T{number}</div>
              <div className="text-xs mt-1 capitalize">{status}</div>
              {table.seats ? (
                <div className="text-xs mt-1 text-gray-700">{table.seats} seats</div>
              ) : null}
            </button>
          );
        })}
        {safeTables.length === 0 && !loading && (
          <p className="col-span-4 text-sm text-gray-500 text-center py-8">
            No tables yet. Tap "Add Table" to create one.
          </p>
        )}
      </div>
    </div>
  );
};

export default TablePicker;
